import React, { useEffect } from 'react'
import Dropdown from './Dropdown'

export default function DashboardReviewsReport({ memberGroup,id, topReviews, topRecommendations, reportCourseID, reportTopReviews, filter, setFilter }) {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div className='container'>
            <Dropdown memberGroup={memberGroup} filter={filter} setFilter={setFilter} instructorId={id} reportTopReviews={reportTopReviews} reportCourseID={reportCourseID} topReviews={topReviews} topRecommendations={topRecommendations} />
        </div>
    )
}
